"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
import { errorCopy } from "@/lib/errorCopy";

// global-error replaces the root layout, so globals.css never loads here —
// every style has to be inline. Values mirror the theme tokens in globals.css.
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = errorCopy();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="tr">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          background:
            "radial-gradient(85% 38% at 6% 0%, rgba(0,214,143,0.13), transparent 62%) #0a0a0a",
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 460px",
          color: "#ffffff",
          fontFamily:
            "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
        }}
      >
        <div style={{ maxWidth: 360, padding: 24, textAlign: "center" }}>
          <div
            style={{
              width: 46,
              height: 46,
              margin: "0 auto",
              display: "grid",
              placeItems: "center",
              borderRadius: 13,
              background: "rgba(239,68,68,0.12)",
              border: "1px solid rgba(239,68,68,0.2)",
              color: "#f87171",
            }}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden
            >
              <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
              <path d="M12 9v4" />
              <path d="M12 17h.01" />
            </svg>
          </div>

          <h1
            style={{
              margin: "16px 0 0",
              fontSize: 18,
              fontWeight: 600,
              letterSpacing: "-0.02em",
            }}
          >
            {t.title}
          </h1>
          <p
            style={{
              margin: "8px 0 0",
              fontSize: 14,
              lineHeight: 1.6,
              color: "#a0a0a0",
            }}
          >
            {t.message}
          </p>

          <button
            type="button"
            onClick={() => reset()}
            style={{
              marginTop: 20,
              padding: "10px 20px",
              borderRadius: 12,
              border: "1px solid #262626",
              background: "#161616",
              color: "#ffffff",
              fontSize: 14,
              fontWeight: 500,
              cursor: "pointer",
            }}
          >
            {t.retry}
          </button>

          {error.digest && (
            <p
              style={{
                margin: "20px 0 0",
                fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
                fontSize: 11,
                letterSpacing: "0.06em",
                color: "#4a4a4a",
              }}
            >
              #{error.digest}
            </p>
          )}
        </div>
      </body>
    </html>
  );
}
